import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NOB from '../../../../constants/language-strings';
import { getHours, getMinutes } from '../../../../utils/time-utils/time-calculator';
import styled from 'styled-components';
import { purpurColorPurple100, purpurColorPurple50 } from '@purpurds/tokens/color/variables';
const OrderedProductsContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  @media (min-width: 750px) {
    flex: 1;
    margin-left: 10px;
  }
`;
const ProductList = styled.div `
  flex: 1;
  font-size: 18px;
  font-weight: 300;

  div:first-child {
    border-radius: 4px 4px 0 0;
  }

  div:last-child {
    border-radius: 0 0 4px 4px;
  }

  div:only-child {
    border-radius: 4px;
  }
`;
const Headings = styled.div `
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  padding-left: 16px;
  padding-bottom: 5px;
  font-size: 20px;
`;
const ProductItem = styled.div `
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  padding: 4px 8px 4px 12px;
  min-height: 26px;

  div:first-child {
    margin-left: 10px;
  }

  &:nth-child(odd) {
    background-color: ${purpurColorPurple100};
  }

  &:nth-child(even) {
    background-color: ${purpurColorPurple50};
  }
`;
export const OrderedProducts = ({ done, orderedItems, technician }) => {
    const showDiagnosis = technician && !done;
    const itemSummary = showDiagnosis
        ? orderedItems.itemSummary.filter(item => item.name.split(' > ').includes(NOB.ORDERED_PRODUCTS.DIAGNOSIS))
        : orderedItems.itemSummary.filter(item => !item.name.includes(NOB.ORDERED_PRODUCTS.DIAGNOSIS));
    const removeDiagnosis = (diagnosisItemName) => diagnosisItemName.replace(`${NOB.ORDERED_PRODUCTS.DIAGNOSIS} >`, '');
    const productsTable = itemSummary.map(product => (_jsxs(ProductItem, { children: [_jsx("div", { children: product.quantity }), _jsx("div", { children: showDiagnosis ? removeDiagnosis(product.name) : product.name }), _jsx("div", { children: `${getHours(product.timeEstimate)} ${getMinutes(product.timeEstimate)}` })] }, product.workOrderServiceId)));
    return (itemSummary.length > 0 && (_jsxs(OrderedProductsContainer, { children: [_jsxs(Headings, { children: [_jsx("div", { children: NOB.ORDERED_PRODUCTS.QUANTITY }), done || !technician
                        ? NOB.ORDERED_PRODUCTS.SERVICE_CODES
                        : NOB.ORDERED_PRODUCTS.DIAGNOSIS, _jsx("div", { children: NOB.ORDERED_PRODUCTS.TIME })] }), _jsx(ProductList, { children: productsTable })] })));
};
